$(window).scroll(function () {
  if ($(this).scrollTop() > 50) {
    $('.scrolltop').stop(true, true).addClass('show');
  } else {
    $('.scrolltop').stop(true, true).removeClass('show');
  }
});
$(function () { $(".scroll").click(function () { $("html,body").animate({ scrollTop: $(".thetop").offset().top }, "1000"); return false }) })
$(document).ready(function () {
  $(".product-form--atc-button").click(function () {

    jQuery.getJSON('/cart.js', function (cart) {
      theplus = parseInt($("#product-quantity-select").val());
      num = cart.item_count + theplus;
      $(".site-header-cart--count").attr('data-header-cart-count', num);
      $(".site-header-cart--count").addClass('visible');
    });
  });
});

/*   // Restricts input for the given textbox to the given inputFilter.
function setInputFilter(textbox, inputFilter) {
  ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function(event) {
    textbox.addEventListener(event, function() {
      if (inputFilter(this.value)) {
        this.oldValue = this.value;
        this.oldSelectionStart = this.selectionStart;
        this.oldSelectionEnd = this.selectionEnd;
      } else if (this.hasOwnProperty("oldValue")) {
        this.value = this.oldValue;
        this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
      } else {
        this.value = "";
      }
    });
  });
}

setInputFilter(document.getElementById("contact_phone"), function(value) {
  return /^-?\d*$/.test(value); }); */

jQuery(document).ready(function ($) {
  var hash = window.location.hash.substring(1);



  hashname = hash.replace('#_', '');
  // find element to scroll to (<a name=""> or anything with particular id)
  //elem = $('a[name="' + hashname + '"],#' + hashname);
  if (window.location.hash) {


    var hasfh = hash.slice(0, -1);

    console.log(hasfh);
    // hash found
  } else {
    // No hash found
  }
  if (hash && hasfh == 'tab') {
    $(".tabbed-content section:not(#" + hash + ")").removeClass("active");
    $("#" + hash).addClass("active");
    //$(document).scrollTo(hash, 800);
    $('.tabbed-content nav li a').removeClass("active");
    $('.tabbed-content nav li a[href="#' + hash + '"]').addClass("active");


    $('html, body').animate({
      scrollTop: $("section.tabbed-content").offset().top - 400
    }, 'slow');
  }

});

var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}